




import { Component, Vue } from 'vue-property-decorator';
import payment from '@/store/modules/payment';
import store from '@/store';

@Component({})
export default class HipayApplePay extends Vue {
    private mounted() {
        const hipayApplePayConfig = store.state.options.payment.hipay_applepay;

        payment.unregisterMethod('hipay_applepay').then(() => {
            payment.registerMethod({ methodCode: 'hipay_applepay', params: hipayApplePayConfig });
        });
    }
}
